import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  cartDetails: {
    fontWeight: "bold",
    marginTop: 30,
    marginLeft: 42,
  },
  divider: {
    marginTop: 30,
  },
  heading: {
    fontWeight: "bold",
    marginTop: 30,
    marginLeft: 137,
    marginRight: 130,
  },
  cartWidth: {
    maxWidth: "70%",
  },
  summary: {
    width: 300,
    height: 800,
    paddingTop: 80,
    marginLeft: 100,
    backgroundColor: "rgb(238, 238, 238)",
  },
  products: {
    width: 50,
    marginTop: 20,
    marginLeft: 40,
  },
  name: {
    width: 250,
    marginTop: 20,
    marginLeft: 30,
  },
  productDivider: {
    marginTop: 10,
  },
  image: {
    width: 80,
    height: 70,
  },
  summaryCart: {
    width: 300,
    height: 650,
    paddingTop: 80,
    marginLeft: 100,
    backgroundColor: "rgb(238, 238, 238)",
  },
  summaryItems: {
    marginTop: 100,
  },
  button: {
    marginLeft: 36,
    marginTop: 100,
  },
  footer: {
    marginBottom: 60,
  },
});
